import { handleErr } from 'utils/functions';
import { useLazyGetEntitlementsQuery } from 'store/slices/access';
import { useFeature } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'types';
import { useSelector } from 'store';
import { useEffect } from 'react';

export function useGetEntitlements() {
  const tempMetronomeEntitlements = useFeature(
    FeatureFlags.tempMetronomeEntitlements
  ).on;
  const { activeOrgId } = useSelector((state) => state.org);

  // Need to ensure we re-request entitlements when Org changes
  // Perhaps make this a lazy query that we call when activeOrgId changes, like in octaneContext.tsx
  const [
    getEntitlements,
    { data: metronomeEntitlements, isLoading: isLoadingMetronomeEntitlements },
  ] = useLazyGetEntitlementsQuery();

  const fetchEntitlements = async () => {
    try {
      await getEntitlements().unwrap();
    } catch (err) {
      handleErr(err, (__: string) => {});
    }
  };

  // If the feature flag is active, request entitlements upon active org change
  useEffect(() => {
    if (tempMetronomeEntitlements) {
      fetchEntitlements();
    }
  }, [activeOrgId]);

  return {
    metronomeEntitlements,
    isLoadingMetronomeEntitlements,
  };
}
